import React, { useState } from "react";

import { connect } from "react-redux";
import { Link, useNavigate } from "react-router-dom";

// import LanguageDropdown from "../../components/Common/TopbarDropdown/LanguageDropdown";
// import NotificationDropdown from "../../components/Common/TopbarDropdown/NotificationDropdown";

//i18n
import { withTranslation } from "react-i18next";

//import images
import logoDefender from "../../assets/images/logo-defender.svg";

// Redux Store
import {
  showRightSidebarAction,
  toggleLeftmenu,
  changeSidebarType,
} from "../../store/actions";
import ProfileMenu from "../../components/Common/TopbarDropdown/ProfileMenu";
// import AppsDropdown from "../../components/Common/TopbarDropdown/AppsDropdown";
import { Toast, ToastBody, ToastHeader } from "reactstrap";

//firebase notification
// import { initFirebaseBackend } from "../../helpers/firebase_helper";
// import config from "../../config";
// import MessagesDropdown from "../../components/Common/TopbarDropdown/MessagesDropdown";
// import BusinessMenu from "../../components/Common/TopbarDropdown/BusinessMenu";

const Header = (props) => {
  // const [search, setsearch] = useState(false);
  const [inputSearch, setinputSearch] = useState("")
  const [isShowNotification, setIsShowNotification] = useState(false);
  const [notification, ] = useState({});
  const navigate = useNavigate()

   /*const instanceFirebase = initFirebaseBackend(config.firebaseConfig);
  instanceFirebase.requestForToken()
  instanceFirebase
    .onMessageListener()
    .then((payload) => {
      if(payload){
        setIsShowNotification(true);
        setNotification({
          title: payload.notification.title,
          body: payload.notification.body,
        });
      }
    })
    .catch((err) => console.log("failed: ", err));*/

  function toggleFullscreen() {
    if (
      !document.fullscreenElement &&
      /* alternative standard method */ !document.mozFullScreenElement &&
      !document.webkitFullscreenElement
    ) {
      // current working methods
      if (document.documentElement.requestFullscreen) {
        document.documentElement.requestFullscreen();
      } else if (document.documentElement.mozRequestFullScreen) {
        document.documentElement.mozRequestFullScreen();
      } else if (document.documentElement.webkitRequestFullscreen) {
        document.documentElement.webkitRequestFullscreen(
          Element.ALLOW_KEYBOARD_INPUT
        );
      }
    } else {
      if (document.cancelFullScreen) {
        document.cancelFullScreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitCancelFullScreen) {
        document.webkitCancelFullScreen();
      }
    }
  }

  function tToggle() {
    var body = document.body;
    if (window.screen.width <= 998) {
      body.classList.toggle("sidebar-enable");
    } else {
      body.classList.toggle("vertical-collpsed");
      body.classList.toggle("sidebar-enable");
    }
  }

  const handleInputSearch = (e) => {
    e?.preventDefault()
    if(inputSearch.length){
      navigate('/BI_WS0001?filter='+encodeURIComponent(inputSearch))
    }
  }

  return (
    <React.Fragment>
      <header id="page-topbar">
        <div className="navbar-header">
          <div
            className="position-fixed top-0 end-0 p-3"
            style={{ zIndex: "1005" }}
          >
            <Toast isOpen={isShowNotification}>
              <ToastHeader
                toggle={() => setIsShowNotification(!isShowNotification)}
              >
                {notification?.title || "undefined"}
              </ToastHeader>
              <ToastBody color="primary">
                {notification?.body || "undefined"}
              </ToastBody>
            </Toast>
          </div>
          <div className="d-flex">
            <div className="navbar-brand-box text-center">
              {/* <Link to="/" className="logo logo-dark">
                <span className="logo-sm">
                  <img src={logoSm} alt="logo-sm-dark" height="22" />
                </span>
              </Link>

              <Link to="/" className="logo logo-light">
                <span className="logo-sm">
                  <img src={logoSm} alt="logo-sm-light" height="22" />
                </span>
                <span className="logo-lg">
                  <img src={logoLight} alt="logo-light" height="41" />
                </span>
              </Link> */}
              <Link to="/" className="logo">
                <span className="logo-defender">
                  <img src={logoDefender} />
                </span>
              </Link>
            </div>

            <button
              type="button"
              className="btn btn-sm px-3 d-lg-none d-sm-block font-size-24 header-item waves-effect"
              id="vertical-menu-btn"
              onClick={() => {
                tToggle();
              }}
            >
              <i className="ri-menu-2-line align-middle"></i>
            </button>

            {/* <form className="app-search d-none d-lg-block px-4">
              <div className="position-relative">
                <span className="ri-search-line"></span>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Pesquisar..."
                />
              </div>
            </form> */}
          </div>

          <div className="d-flex">
            {/* <div className="dropdown d-inline-block d-lg-none ms-2">
              <button
                onClick={() => {
                  setsearch(!search);
                }}
                type="button"
                className="btn header-item noti-icon "
                id="page-header-search-dropdown"
              >
                <i className="ri-search-line" />
              </button>
              <div
                className={
                  search
                    ? "dropdown-menu dropdown-menu-lg dropdown-menu-end p-0 show"
                    : "dropdown-menu dropdown-menu-lg dropdown-menu-end p-0"
                }
                aria-labelledby="page-header-search-dropdown"
              >
                <form className="p-3">
                  <div className="form-group m-0">
                    <div className="input-group">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Search ..."
                        aria-label="Recipient's username"
                      />
                      <div className="input-group-append">
                        <button className="btn btn-primary" type="submit">
                          <i className="ri-search-line" />
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div> */}

            <form className="app-search px-4" onSubmit={handleInputSearch}>
              <div className="position-relative">
                <i onClick={handleInputSearch} className="fas fa-search flip-icon"></i>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Busca"
                  onChange={(e) => {
                    const regex = /^\s*$/;
                    if (regex.test(e.target.value)) return
                    setinputSearch(e.target.value)}}                
                />
              </div>
            </form>

            {/* <LanguageDropdown /> */}
            {/* <AppsDropdown /> */}

            {/* <div className="dropdown d-none d-lg-inline-block ms-1">
              <button
                type="button"
                onClick={() => {
                  toggleFullscreen();
                }}
                className="btn header-item noti-icon"
                data-toggle="fullscreen"
              >
                <i className="ri-fullscreen-line" />
              </button>
            </div> */}

            <div className="position-relative">
              <a href={"/BI_WS0020"} className="px-3 header-item noti-icon d-flex align-items-center">
                <i className="far fa-comments text-light"></i>
                {/* <span className="noti-dot">1</span> */}
              </a>
            </div>

            <div className="position-relative">
              <a href={"/BI_WS0021"} className="px-3 header-item noti-icon d-flex align-items-center">
                <i className="far fa-bell text-light"></i>
                {/* <span className="noti-dot">1</span> */}
              </a>
            </div>

            {/* <MessagesDropdown />
            <NotificationDropdown /> */}

            {/* <div
              className="dropdown d-inline-block"
              onClick={() => {
                props.showRightSidebarAction(!props.showRightSidebar);
              }}
            >
              <button
                type="button"
                className="btn header-item noti-icon right-bar-toggle waves-effect"
              >
                <i className="mdi mdi-cog"></i>
              </button>
            </div> */}

            <ProfileMenu />
            {/* <BusinessMenu /> */}
          </div>
        </div>
      </header>
    </React.Fragment>
  );
};

const mapStatetoProps = (state) => {
  const { layoutType, showRightSidebar, leftMenu, leftSideBarType } =
    state.Layout;
  return { layoutType, showRightSidebar, leftMenu, leftSideBarType };
};

export default connect(mapStatetoProps, {
  showRightSidebarAction,
  toggleLeftmenu,
  changeSidebarType,
})(withTranslation()(Header));
